import { useEffect, useState } from 'react'

import constate from 'constate'

import NProgress from 'nprogress'

import type { SystemConfig } from '@/types'
import { api } from '@/utils'

const Container = () => {
  const [notification, setNotification] = useState({ type: '', message: '' })
  const [systemConfig, setSystemConfig] = useState<SystemConfig>()
  const [overlayMegaMenu, setOverlayMegaMenu] = useState<boolean>(false)

  const showNotification = (message: string, type: string) => {
    setNotification({ type, message })
    setTimeout(() => {
      setNotification({ type, message: '' })
    }, 4000)
  }

  useEffect(() => {
    setOverlayMegaMenu(false)
  }, [])

  const showProgressBar = () => {
    NProgress.remove()
    NProgress.start()
  }

  const hideProgressBar = () => {
    NProgress.done()
  }

  useEffect(() => {
    if (!systemConfig) {
      api(`api/configuration`, {
        baseURL: process.env.NEXT_PUBLIC_IAM_API_URL,
        method: 'get'
      })
        .then(res => {
          if (res && !(res instanceof Error)) {
            setSystemConfig(res.data)
          }
        })
        .catch(() => null)
    }
  }, [])

  return {
    notification,
    setNotification,
    showNotification,
    showProgressBar,
    hideProgressBar,
    systemConfig,
    overlayMegaMenu,
    setOverlayMegaMenu
  }
}

export const [NotificationProvider, useNotification] = constate(Container)
